import { gql } from '@/__generated__/gql';

export const CREATE_LEGAL_ENTITY_MUTATION = gql(`
  mutation EditInvestorPageCreateLegalEntity($data: CreateLegalEntityInput!) {
    createLegalEntity(data: $data) {
      id
      family {
        id
      }
    }
  }
`);

export const UPDATE_LEGAL_ENTITY_MUTATION = gql(`
  mutation EditInvestorPageUpdateLegalEntity($data: UpdateLegalEntityInput!) {
    updateLegalEntity(data: $data) {
      id
      family {
        id
        name
      }
    }
  }
`);

export const DELETE_LEGAL_ENTITY_MUTATION = gql(`
  mutation EditInvestorPageDeleteLegalEntity($id: String!) {
    deleteLegalEntity(id: $id)
  }
`);

export const CREATE_INVESTOR_MUTATION = gql(`
  mutation EditInvestorPageCreateInvestor($data: InvestorCreateDto!) {
    createInvestor(data: $data) {
      id
      name
    }
  }
`);

export const UPDATE_INVESTOR_MUTATION = gql(`
  mutation EditInvestorPageUpdateInvestor($data: InvestorUpdateDto!) {
    updateInvestor(data: $data) {
      id
    }
  }
`);

export const EDIT_INVESTOR_PAGE_LIST_INVESTOR_HOUSEHOLDS_QUERY = gql(`
  query EditInvestorPageListInvestorHouseholds($data: InvestorListInputDto!) {
    listInvestors(data: $data) {
      data {
        id
        name
      }
    }
  }
`);

export const EDIT_INVESTOR_PAGE_HOUSEHOLD_SECTION_QUERY = gql(`
  query EditInvestorPageHouseholdSection($data: getInvestorDto!) {
    getInvestor(data: $data) {
      id
      name
      tenant {
        id
        name
      }
      advisor {
        id
        firstName
        lastName
        roles
      }
    }
  }
`);

export const EDIT_INVESTOR_PAGE_LIST_USERS_QUERY = gql(`
  query EditInvestorPageListUsers($filters: ListUsersFilterDto!) {
    listUsers(filters: $filters) {
      id
      firstName
      lastName
    }
  }
`);

export const EDIT_INVESTOR_PAGE_GROUP_BY_PRIMARY_ENTITY_ID_QUERY = gql(`
  query EditInvestorPageGroupByPrimaryEntityId($data: GetGroupInput!) {
    group(data: $data) {
      id
      name
      custodied
      unmanaged
      alwaysShow
      ignoreAllocationTargets
      ignoreBiteSize
      sectorsToAvoid
      impact
      onHold
      defaultBiteSize1
      defaultBiteSize2
      targetOCRatio
      privatePercentage
      totalEntityValue
      tenant {
        id
        name
      }
      allocationTargets {
        id
        percentage
        assetClass {
          id
          name
          subAssetClass {
            id
            name
          }
        }
      }
      drawdownTargets {
        actuals {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
        targets {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
      }
    }
  }
`);

export const EDIT_INVESTOR_PAGE_LEGAL_ENTITY_QUERY = gql(`
  query EditInvestorPageLegalEntity($id: String!) {
    legalEntity(id: $id) {
      id
      entityName
      aboutInvestorNote
      entityInception
      custodied
      unmanaged
      sri
      category
      entityType
      otherType
      eligibility
      alwaysShow
      ignoreAllocationTargets
      ignoreBiteSize
      sectorsToAvoid
      taxExempt
      taxStatus
      onHold
      defaultBiteSize1
      defaultBiteSize2
      targetOCRatio
      privatePercentage
      totalEntityValue
      advisorReportingAccountNumber
      advisorCRMId
      administratorCode
      tenant {
        id
        name
      }
      allocationTargets {
        id
        percentage
        assetClass {
          id
          name
          subAssetClass {
            id
            name
          }
        }
      }
      drawdownTargets {
        actuals {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
        targets {
          drawdown {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
          evergreen {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
            subAssetClassDrawdownTargets {
              id
              name
              portfolioPercentage
              privateCapitalPercentage
            }
          }
        }
      }
    }
  }
`);

export const EDIT_INVESTOR_PAGE_DEFAULT_DRAWDOWN_TARGETS_QUERY = gql(`
  query EditInvestorPageDefaultDrawdownTargets($tenantId: String) {
    defaultDrawdownTargets(tenantId: $tenantId) {
      actuals {
        drawdown {
          id
          name
          portfolioPercentage
          privateCapitalPercentage
          subAssetClassDrawdownTargets {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
          }
        }
        evergreen {
          id
          name
          portfolioPercentage
          privateCapitalPercentage
          subAssetClassDrawdownTargets {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
          }
        }
      }
      targets {
        drawdown {
          id
          name
          portfolioPercentage
          privateCapitalPercentage
          subAssetClassDrawdownTargets {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
          }
        }
        evergreen {
          id
          name
          portfolioPercentage
          privateCapitalPercentage
          subAssetClassDrawdownTargets {
            id
            name
            portfolioPercentage
            privateCapitalPercentage
          }
        }
      }
    }
  }
`);

export const ALL_ENTITY_CATEGORIES_QUERY = gql(`
  query AllEntityCategories {
    entityCategories {
      category
      entityTypes
    }
  }
`);
